export const ADMISSION_EXPIRED_SESSION_ROUTE = "/workflow/session-expired";
